import Immutable from 'immutable';
import { createDeepEqualSelector } from './redux';

const ABISKO_PROJECT = 'svtplay';

const selectAllocations = (state) => state.getIn(['abisko', ABISKO_PROJECT, 'allocations'], Immutable.Map());

const getPrefixedAllocations = (allocations, prefix) =>
    Object.keys(allocations)
        .filter((key) => key.startsWith(prefix))
        .filter((key) => allocations[key].variantSlug !== null)
        .map((key) => ({
            project: ABISKO_PROJECT,
            experiment: key,
            variant: allocations[key].variantSlug,
        }));

export const getContentoAbTestVariants = createDeepEqualSelector([selectAllocations], (allocations) => {
    const allocationsObject = allocations.toJS();

    return getPrefixedAllocations(allocationsObject, 'contento-');
});

export const geSurveyAbTestVariants = createDeepEqualSelector([selectAllocations], (allocations) => {
    const allocationsObject = allocations.toJS();

    return getPrefixedAllocations(allocationsObject, 'survey-');
});

export const getAbTestVariants = createDeepEqualSelector([selectAllocations], (allocations) => {
    const allocationsObject = allocations.toJS();

    return Object.keys(allocationsObject)
        .filter((key) => allocationsObject[key].variantSlug !== null)
        .map((key) => ({
            project: ABISKO_PROJECT,
            experiment: key,
            variant: allocationsObject[key].variantSlug,
        }));
});
